import {useEffect, useState} from 'react';

export interface State {
  x: number;
  y: number;
}

export const useWindowScroll = (): State => {
  const [state, setState] = useState<State>(() => ({
    x: 0, //window.pageXOffset,
    y: 0, //window.pageYOffset,
  }));

  useEffect(() => {
    const handler = () => {
      setState((state) => {
        const {pageXOffset, pageYOffset} = window;
        return state.x !== pageXOffset || state.y !== pageYOffset
          ? {
              x: pageXOffset,
              y: pageYOffset,
            }
          : state;
      });
    };

    handler();

    window.addEventListener('scroll', handler);

    return () => window.removeEventListener('scroll', handler);
  }, []);

  return state;
};
